module.exports = __webpack_public_path__ + "img/Icon-star-left.7e1f00e4.svg";